module.exports = __webpack_public_path__ + "static/media/ic_rectangle.0e641a44.svg";